module.exports = __webpack_public_path__ + "static/media/Vital Vårdcentral Malmö uses Curoflow Telemedicine platform.2e69c861.webp";